<template>
  <div>
    <div class="input-style">
      <input
        id="mail"
        :value="mailValue"
        type="mail"
        placeholder="メールアドレス"
        @change="changeMail"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mailValue: ""
    };
  },
  methods: {
    changeMail(e) {
      const val = e.target.value;
      this.mailValue = val;
      this.$emit("handle-change-mail", this.mailValue);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/molecules/InputMail.vue